module.exports = __webpack_public_path__ + "f78cd8cfb1043ccb934dd607074c9ae5.pdf";